var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Link, Trans, translate, Typography } from '@lucidlink/uicore';
import { FILESPACE_SETTINGS_ARTICLE_URL } from '#constants';
export const FilespaceSettingsFooter = () => {
    return (_jsxs(Box, { align: "end", gap: "s", children: [_jsx(Typography, { kind: "generic-small", children: _jsx(Trans, { children: "Additional advanced settings can be configured via the CLI." }) }), _jsx(Link, { "aria-label": translate('Learn more about advanced filespace settings'), "data-testid": "global-defaults-article", kind: "subtle", target: "_blank", to: FILESPACE_SETTINGS_ARTICLE_URL, children: _jsx(Trans, { children: "Learn more" }) })] }));
};
_react_refresh_temp_1 = FilespaceSettingsFooter;
$RefreshReg$(_react_refresh_temp_1, "FilespaceSettingsFooter");
